export const UI = {
    primary: "#ec7f13",
    bgMain: "#f8fafc",
    border: "rgba(15, 23, 42, 0.06)",
    textMuted: "#64748b",
    cardRadius: "1.5rem", // Reduced from 2rem
};

export const qrPlaceholderSx = {
    borderRadius: "0.75rem",
    border: "1px solid rgba(15, 23, 42, 0.04)",
    backgroundImage:
        "linear-gradient(45deg, var(--fx-surface-muted, #F1F5F9) 25%, var(--fx-surface-base, #FFFFFF) 25%, var(--fx-surface-base, #FFFFFF) 50%, var(--fx-surface-muted, #F1F5F9) 50%, var(--fx-surface-muted, #F1F5F9) 75%, var(--fx-surface-base, #FFFFFF) 75%, var(--fx-surface-base, #FFFFFF) 100%)",
    backgroundSize: "1rem 1rem", // Reduced from 1.25rem
};
